<div class="content-header">
  <div class="container-fluid">
    <div class="row mb-2">
      <div class="col-sm-6">
        <h1></h1>
      </div>
      <div class="col-sm-6">
        <ol class="breadcrumb float-sm-right">
          <li class="breadcrumb-item">
            <router-link to="/">Home</router-link>
          </li>
          <li class="breadcrumb-item active">Upload</li>
        </ol>
      </div>
    </div>
  </div>
</div>

<section class="upload-container">
  <div class="row">
    <div id="type-container" class="col-6">
      <label for="file-type">Tipo:</label>
      <select class="file-type" v-model="type">
        <option disabled selected value></option>
        <option value="sim">SIM</option>
        <option value="sinam">SINAM</option>
        <option value="esus">ESUS</option>
        <option value="sia">SIA</option>
        <option value="sih">SIH</option>
      </select>
      <span v-if="errors.type" class="error">{{ errors.type }}</span>
    </div>

    <div id="file-container" class="col-6">
      <label for="files">Arquivo:</label>
      <input type="file" id="files" @change="file = $event.target.files[0]"/>
      <span v-if="errors.file" class="error">{{ errors.file }}</span>
    </div>

    <div class="col-12 text-center mg-t-25">
      <input type="submit" value="ENVIAR" class="submit-btn" @click="handleSubmit">
    </div>
  </div>
</section>

<section class="files-table">
  <div>
    <h3>Histórico</h3>
    <table-lite 
      :rows="table.rows"
      :columns="table.columns" 
      :sortable="table.sortable" 
      :isHidePaging="true" 
      :is-slot-mode="true">
      <template v-slot:status="props">
        <span class="badge" v-bind:class="{
          'bg-success': props.value.status === 'Success',
          'bg-danger': props.value.status === 'Failed'
        }">{{ props.value.status === "Success" ? "Sucesso" : "Falha" }}</span>
      </template>
      <template v-slot:createdAt="props">
        {{ props.value.createdAt ? formatDate(props.value.createdAt) : '-' }}
      </template>
    </table-lite>
  </div>
</section>
